module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gUTDRQlcGb3aQAAAHdJREFUSMfNlbkRwCAMBNEVq34IoF07coI9HvSjiEC6ZxOIma9WMGhFgzk6ZZvO0QnPI9O0FvWaJKPtq3Gk+apdjzqy9Zcmdhc9Tc9C7dn6TwPaQ4vpmagtrXdu4CUk3YW3YMl/LAkHL2EpEUS2CketCQOrkZbADYuNMwlZzG6IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/jiantou_geren_icon.png
// module id = 178
// module chunks = 0